
import { Component, Prop, VModel, Vue } from "vue-property-decorator";
import WithdrawMoneyContent from "@/components/profile/WithdrawMoneyContent.vue";
import BottomSheet from "@/components/base/BottomSheet.vue";
import { UserItemEntity } from "@/entities/user-item.entity";

@Component({
  components: {
    WithdrawMoneyContent,
    BottomSheet,
  },
})
export default class WithdrawMoneyBottomSheet extends Vue {
  @VModel({ type: Boolean }) show!: boolean;
  @Prop() items!: UserItemEntity[];
}
